import AxiosControl from '../components/axios/AxiosControl'
import { getErrorMessage, getResponseData, getResponseMessage, isSuccessResponse } from '../helpers/apiResponse'
const Axios = AxiosControl()

export const getDepartments = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'DEPARTMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/department/getAll', {page, limit, search}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DEPARTMENT_GETALL_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'DEPARTMENT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const getDepartmentsForSelect = () => async (dispatch) => {
    dispatch({
        type: 'DEPARTMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/department/getforselect', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DEPARTMENT_GETALL_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'DEPARTMENT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const getDepartment = (departmentId) => async (dispatch) => {
    dispatch({
        type: 'DEPARTMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/department/get/'+ departmentId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DEPARTMENT_GET_SUCCESS',
                payload: getResponseData(data).department
            })
        }
    } catch (error) {
        dispatch({
            type: 'DEPARTMENT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const addDepartment = (departmentdata) => async (dispatch) => {
    dispatch({
        type: 'DEPARTMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/department/create', departmentdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DEPARTMENT_ADD_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'DEPARTMENT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const editDepartment = (departmentId, departmentdata) => async (dispatch) => {
    dispatch({
        type: 'DEPARTMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/department/edit/'+ departmentId, departmentdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'DEPARTMENT_EDIT_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'DEPARTMENT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const resetDepartmentResult = () => (dispatch) => {
    dispatch({
        type: 'DEPARTMENT_RESET_RESULT'
    })
}
